//------------------------------------------------------------------------------
// This file is auto-generated.
//------------------------------------------------------------------------------
// This file was generated by NTypewriter from the C# ViewModel class with the
// same class/interface name.
//
// Do not change this file.  Any changes may cause incorrect behaviour and will
// be lost if the code is regenerated.
//------------------------------------------------------------------------------

import { ItemBase } from '../internal/ItemBase';

export class ParentContactDisplayItem extends ItemBase {
    ID: string | null = null;
    FirstName: string | null = null;
    LastName: string | null = null;
    FullName: string | null = null;
    HomePhone: string | null = null;
    MobilePhone: string | null = null;
    WorkPhone: string | null = null;
    EmailAddress: string | null = null;

    constructor(initializer?: Partial<ParentContactDisplayItem>) {
        super();
        if (initializer) {
            Object.assign(this, initializer);
        }
    }

    static readonly ClassName: string = "ParentContactDisplayItem";
}
